const request = require('request')
const util = require('util')

module.exports = (baseUrl) => {
  let myRequest = request.defaults({
    baseUrl
  })
  return {
    get: util.promisify(myRequest.get),
    post: util.promisify(myRequest.post),
    put: util.promisify(myRequest.put),
    del: util.promisify(myRequest.delete),
  }
}
